import React, { useEffect, useState } from "react";
import { Segmented } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import "./Billing.scss";
import utils from "utils";
import NewBill from "./NewBill";
import BillingHistory from "./BillingHistory";
import { useLocation, useHistory } from "react-router-dom";
function VitalForm(props) {
  const location = useLocation();
  const history = useHistory();
  const VendorDetail = location.state?.VendorDetail;
  const selectedTabVendor = location.state?.selectedTab;
  const [selectedTab, setSelectedTab] = useState(selectedTabVendor||"billingHistory");
  const [formActionState, formAction] = useState(false);
  const handleTabChange = (tab) => {
    setSelectedTab(tab);
  };
  const unsavedPopup = (key) => {
    utils.Modal(true, {
      width: "650px",
      // closable: false,
      content: (
        <div className="finish-Consult-Modal">
          <div className="finish-header">Switch Tab</div>
          <div className="finish-wrapper">
            <div className="finish-title">
              There are unsaved changes. Are you sure to switch Tab?
            </div>
            <div className="finish-btns">
              <button
                className="action-yes"
                onClick={() => {
                  setSelectedTab(key), utils.Modal(false);
                }}
              >
                Yes
              </button>
              <button
                className="action-no"
                onClick={() => {
                  utils.Modal(false);
                }}
              >
                No
              </button>
            </div>
          </div>
        </div>
      ),
    });
  };
  return (
    <div className="billing">
      <div
        className="billingDetailSwitch"
        // style={{
        //   display: "flex",
        //   alignItems: "center",
        //   justifyContent: "center",
        // }}
      >
        <Segmented
          style={{ width: "100%" }}
          size="large"
          value={selectedTab}
            onChange={formActionState ? unsavedPopup : handleTabChange}
          // onChange={handleTabChange}
          options={[
            {
              label: <div>Billing History</div>,
              value: "billingHistory",
            },
            {
              label: (
                <div>
                  <PlusOutlined />
                  New Bill
                </div>
              ),
              value: "newBill",
            },
          ]}
        />
      </div>

      <div style={{ marginTop: "20px" }} className="billingMainContent">
        {selectedTab == "billingHistory" && (
          <BillingHistory formAction={formAction} VendorDetail={VendorDetail}/>
        )}
        {selectedTab == "newBill" && <NewBill formAction={formAction} VendorDetail={VendorDetail} submitButtonAction={()=>{handleTabChange("billingHistory");}}/>}
      </div>
    </div>
  );
}

export default VitalForm;
